export enum HookTypeEnum {
    DB = 'db',
    HTTP = 'http',
}
